import React from "react";
import { RCCBadge} from "react-common-components";
import IComponentBadge from "react-common-components/dist/components/Badge/interface";
import { useTranslation } from "src/context/Translations/context";
import { CheckImpact, CheckProbability, CheckQuadrant, RisksSituation } from "../../interface";
import { TypeBadge } from "../ListAnalysis/interface";
import { IBadgeAnalysis } from "./interface";


const BadgeAnalysis: React.FC<IBadgeAnalysis> = ({
	value,
	type,
	styleInline
}) => {

	const {translate} = useTranslation();

	// Impact
	const textImpact = () => {
		switch (value) {
		case CheckImpact.LOW:
			return translate("Baixo"); 
		case CheckImpact.VERY_LOW:
			return  translate("Muito baixo");
		case CheckImpact.MODERATE:
			return translate("Moderado");
		case CheckImpact.HIGH:
			return translate("Alto");
		case CheckImpact.VERY_HIGH:
			return translate("Muito alto");
    
		default:
			return  " ";
		} 
	};
    
	const colorImpact = () => {
		let color: IComponentBadge["color"];
		switch (value) {
		case CheckImpact.VERY_LOW:
			color = "blue";
			break; 
		case CheckImpact.LOW:
			color = "green";
			break; 
		case CheckImpact.MODERATE:
			color = "yellow";
			break; 
		case CheckImpact.HIGH:
			color = "orange";
			break; 
		case CheckImpact.VERY_HIGH:
			color = "purple";
			break; 
		default:
			color = undefined;
			break; 
		}
		return color;

	};

	// Probability
	const textProbability = () => {
		switch (value) {
		case CheckProbability.LOW:
			return translate("Baixo"); 
		case CheckProbability.VERY_LOW:
			return  translate("Muito baixo");
		case CheckProbability.MODERATE:
			return translate("Moderado");
		case CheckProbability.HIGH:
			return translate("Alto");
		case CheckProbability.VERY_HIGH:
			return translate("Muito alto");
    
		default:
			return  translate("Error");
		} 
	};
    
	const colorProbability = () => {
		let color: IComponentBadge["color"];
		switch (value) {
		case CheckProbability.VERY_LOW:
			color = "blue";
			break; 
		case CheckProbability.LOW:
			color = "green";
			break; 
		case CheckProbability.MODERATE:
			color = "yellow";
			break; 
		case CheckProbability.HIGH:
			color = "orange";
			break; 
		case CheckProbability.VERY_HIGH:
			color = "purple";
			break; 
		default:
			color = undefined;
			break; 
		}
		return color;

	};

	// Quadrant
	const textQuadrant = () => {
		switch (value) {
		case CheckQuadrant.OPPORTUNITY:
			return translate("Oportunidade"); 
		case CheckQuadrant.THREAT:
			return  translate("Ameaça");
		default:
			return  " ";
		} 
	};
    
	const colorQuadrant = () => {
		let color: IComponentBadge["color"];
		switch (value) {
		case CheckQuadrant.OPPORTUNITY:
			color = "purple";
			break; 
		case CheckQuadrant.THREAT:
			color = "red";
			break; 
		default:
			color = undefined;
			break; 
		}
		return color;

	};

	// Situation
	const textSituation = () => {
		switch (value) {
		case RisksSituation.OPEN:
			return translate("Aberto"); 
		case RisksSituation.FINALY:
			return  translate("Finalizado");
		case RisksSituation.CANCELED:
			return  translate("Cancelado");
		default:
			return  " ";
		} 
	};
	
	const colorSituation = () => {
		let color: IComponentBadge["color"];
		switch (value) {
		case RisksSituation.OPEN:
			color = "green";
			break; 
		case RisksSituation.FINALY:
			color = "blue";
			break; 
		case RisksSituation.CANCELED:
			color = "black";
			break;
		default:
			color = undefined;
			break; 
		}
		return color;

	};

	return (
		<>
			{type === TypeBadge.IMPACT && (
				<RCCBadge color={colorImpact()}
					styleInline={styleInline}
				>
					{textImpact()}
				</RCCBadge>
			)}

			{type === TypeBadge.PROBABILITY && (
				<RCCBadge color={colorProbability()}
					styleInline={styleInline}
				>
					{textProbability()}
				</RCCBadge>
			)}

			{type === TypeBadge.QUADRANT && (
				<RCCBadge color={colorQuadrant()}
					styleInline={styleInline}
				>
					{textQuadrant()}
				</RCCBadge>
			)}

			{type === TypeBadge.SITUATION && (
				<RCCBadge color={colorSituation()}
					styleInline={styleInline}
				>
					{textSituation()}
				</RCCBadge>
			)}
		</>
	);
};

export default BadgeAnalysis;
